export const BILLING_ADDRESS = "BILLING_ADDRESS";
export const DELIVERY_ADDRESS = "DELIVERY_ADDRESS";
